import { toResponseError, type QuizData, type QuizUpdateInput, type QuizUpdateSuccess } from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useQuizCache } from './cache'

export function useUpdateQuiz(): UpdateHookResponse<QuizUpdateInput['quiz'], QuizData> {
  const mutation = useTantalimMutation<QuizUpdateInput, QuizUpdateSuccess>({
    url: '/quiz/update',
  })
  const cache = useQuizCache()

  async function update(quiz: QuizUpdateInput['quiz']): Promise<QuizData> {
    try {
      const { quiz: updatedQuiz } = await mutation.mutateAsync({ quiz })
      cache.setItem(updatedQuiz)
      return updatedQuiz
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
